import { render, staticRenderFns } from "./greenSection.vue?vue&type=template&id=9aa5712e"
import script from "./greenSection.vue?vue&type=script&lang=js"
export * from "./greenSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports